<script lang="ts">
  import { domId } from "../../lib/dom";
  import RadioGroup from "../../components/RadioGroup.svelte";
  import {localizeDate} from "../../lib/date";
  import { type Component } from "svelte";

  let {
    answer,
    back,
    inactive,
    updateFinanceAgreementStartDate,
    financeAgreementStartDate,
    nextStep,
  }: {
    answer: ({ nextStep, status }) => void;
    back: () => void;
    inactive: boolean;
    updateFinanceAgreementStartDate: (startDateInput: string) => void;
    financeAgreementStartDate: string;
    nextStep: Component;
  } = $props();

  let startDateInput = $state(financeAgreementStartDate);
  let warning = $state(null);
  let error = $state(null);
  let selectedOption = $state(financeAgreementStartDate === null ? "changed" : null);

  function handleContinue() {
    verifyDateInput();
    if (allowContinue()) {
      error = null;
      selectedOption === "changed"
        ? updateFinanceAgreementStartDate(startDateInput)
        : updateFinanceAgreementStartDate(financeAgreementStartDate); // In case startDateInput was populated because switching selectedOption
      answer({nextStep, status: selectedOption});
    }
  }

  function allowContinue() {
    return (
      selectedOption === "unchanged" ||
      (selectedOption === "changed" && startDateInput && !error)
    );
  }

  function verifyDateInput() {
    if (selectedOption === "changed") {
      const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD format to compare with the date input
      error = null;
      warning = null;
      if (financeAgreementStartDate === startDateInput) {
        error =
          "Please enter a different date from the original one you provided";
      } else if (startDateInput > today) {
        error = "Are you sure? This date is in the future";
      }
    }
  }

  const startDateId = domId("start-date");
</script>

<div class="h-full">
  <fieldset class="ui-fieldset" class:hidden={financeAgreementStartDate === null}>
    <legend>
      <span>Did you finance this vehicle on <b>{localizeDate(financeAgreementStartDate)}</b>?</span>
    </legend>

    <RadioGroup
      name="finance_date[status]"
      options={[
        ["Yes", "unchanged"],
        ["No", "changed"]
      ]}
      bind:group={selectedOption}
    />
  </fieldset>

  <fieldset class="ui-fieldset" class:hidden={selectedOption !== "changed"}>
    <legend>What was the start date of your finance agreement?</legend>

    <input
      id={startDateId}
      type="date"
      name="finance_date[start_date]"
      class="ui-input"
      disabled={selectedOption !== "changed"}
      bind:value={startDateInput}
    />

    {#if error}<div class="ui-error">{error}</div>{/if}
  </fieldset>
</div>

<div class="floating-footer">
  <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
  <button type="submit" class="btn btn-primary" onclick={handleContinue} disabled={!selectedOption || inactive}
    >Continue</button>
</div>
